<div class="d-flex align-items-start">
  <ng-container *ngFor="let seg of segments; let i = index">
    <ng-container *ngIf="i >= offset">
      <div *ngIf="!open || readonly || i !== currentIndex; else editor" class="d-flex m-2">
        <fa-icon class="me-2" [icon]="['fal', 'chevron-right']"></fa-icon>
        <span *ngIf="readonly">{{ seg }}</span>
        <span *ngIf="!readonly" (click)="editIndex(i)" style="cursor: pointer">{{ seg }}</span>
      </div>
    </ng-container>
  </ng-container>

  <div class="d-flex" *ngIf="canAdd && !readonly && !open">
    <fa-icon class="me-2 m-2" [icon]="['fal', 'chevron-right']"></fa-icon>
    <div class="btn-group btn-group-md" role="group">
      <button class="btn btn-primary" (click)="$event.preventDefault(); add();">
        <fa-icon [icon]="['fal', 'plus']"></fa-icon>
      </button>
      <button *ngIf="path.length > 1" class="btn btn-danger" (click)="$event.preventDefault(); clear();">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </button>
    </div>
  </div>

  <ng-template #editor>
    <div>
      <div class="d-flex">
        <fa-icon class="me-2 m-2" [icon]="['fal', 'chevron-right']"></fa-icon>
        <app-button-input
          type="text"
          class="my-2 mt-0"
          (keyup.enter)="push(name)"
          [initialValue]="''"
          [(value)]="name"
          (apply)="push(name)"
          (cancel)="push(null)"
        ></app-button-input>
      </div>

      <div *ngIf="isLoadingChildren" class="list-group my-2">
        <div class="list-group-item text-muted">
          <fa-icon icon="spinner" [spin]="true" class="me-2"></fa-icon>
          Loading options...
        </div>
      </div>

      <div *ngIf="!isLoadingChildren && options.length > 0" class="list-group my-2">
        <button *ngFor="let o of options" (click)="push(o)" type="button" class="list-group-item list-group-item-action">{{ o }}</button>
      </div>
    </div>
  </ng-template>
</div>
